import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '~/src/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

interface NotFoundPageProps {
  title?: string;
  description?: string;
  showGoBack?: boolean;
  showGoHome?: boolean;
}

export function NotFoundPage({ 
  title = "Page Not Found",
  description = "The page you're looking for doesn't exist or has been moved.",
  showGoBack = true,
  showGoHome = true
}: NotFoundPageProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-muted-foreground">404</h1>
          <h2 className="text-2xl font-semibold mb-2">{title}</h2>
          <p className="text-muted-foreground mb-6">
            {description}
          </p>
        </div>
        
        <div className="space-y-3">
          {showGoHome && (
            <Button onClick={() => navigate('/')} className="w-full">
              <Home className="h-4 w-4 mr-2" />
              Go Home
            </Button>
          )}
          
          {showGoBack && (
            <Button variant="outline" onClick={() => navigate(-1)} className="w-full">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
